'use strict';

var focusHelper = require('base/components/focus');
var purechatUtils = require('friartux/utils/purechat');
var defaultBottomPadding = 25;

const SELECTORS = {
    body: 'body',
    consentTrackingModal: '#consent-tracking',
    consentCtaButton: '.js-cookie-cta button',
    consentContainer: '.cookie-consent .container',
    purechatWidget: '.purechat-display-block',
    purechatWindow: '.purechat-window'
};

function init() {
    $(SELECTORS.body).on('click', SELECTORS.consentCtaButton, function (e) {
        e.preventDefault();
        let url = $(this).data('url');

        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function () {
                $('#consent-tracking').remove();
                $.spinner().stop();
            },
            error: function () {
                $('#consent-tracking').remove();
                $.spinner().stop();
            }
        });
    });

    $(SELECTORS.body).on('keydown', SELECTORS.consentTrackingModal, function (e) {
        let focusParams = {
            event: e,
            containerSelector: SELECTORS.consentTrackingModal,
            firstElementSelector: '.affirm',
            lastElementSelector: '.decline',
            nextToLastElementSelector: '.affirm'
        };

        focusHelper.setTabNextFocus(focusParams);
    });

    // Purechat is Cookiebot-gated (preferences + statistics), so the widget may only
    // appear after the visitor accepts - purechatUtils waits for that.
    purechatUtils.onReady(watchPurechat);
}

function watchPurechat() {
    const consentContainer = $(SELECTORS.consentContainer)[0];
    let purechatApi = window.purechatApi;

    if (!consentContainer) {
        return;
    }

    purechatApi.on('chatbox:ready', function () {
        resizeConsentWindow();
    });

    purechatApi.on('chatbox:collapse', function () {
        let bottomPadding = $(SELECTORS.purechatWidget).height();
        $(SELECTORS.consentContainer).css('padding-bottom', bottomPadding + 'px');
    });

    purechatApi.on('chatbox:minimize', function () {
        $(SELECTORS.consentContainer).css('padding-bottom', defaultBottomPadding + 'px');
    });
}

function resizeConsentWindow() {
    const $pureChatWindow = $(SELECTORS.purechatWindow);
    let bottomPadding = defaultBottomPadding;

    if ($pureChatWindow.hasClass('purechat-widget-collapsed')) {
        bottomPadding = $(SELECTORS.purechatWidget).height();
    }

    $(SELECTORS.consentContainer).css('padding-bottom', bottomPadding + 'px');
}

module.exports = {
    init: init
};
